import { Button, Select, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";

export default function KeyDates() {
    return (
        <TableContainer overflowY={'scroll'}>
            <Table size='sm'>
                <Thead  position={'sticky'} top={'0%'} h={'30px'} bg={'primary.500'} alignItems={'flex-start'}>
                    <Tr>
                        <Th
                            color={'white'}
                        >
                            Requirements
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Due Date
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Repeating Period
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Overdue Flag
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Status
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    <Tr>
                        <Td>Annual Accounts</Td>
                        <Td>dd-mm-yyyy</Td>
                        <Td>
                            <Select w={'100%'}>
                                <option value="option1">Anually</option>
                                <option value="option2">Bi-Anually</option>
                            </Select>
                        </Td>
                        <Td textAlign={'center'}>
                            <Button
                                bg={"gray.600"}
                                _hover={{ bg: "gray.700" }}
                                _active={{ bg: "gray.800" }}
                                color={'white'}
                                size={'md'}
                            >
                                -
                            </Button>
                        </Td>
                        <Td>
                            <Button
                                size={'md'}
                                leftIcon={<FaCheck />}
                                color={'white'}
                                bg={'green.500'}
                                _hover={{ bg: 'green.600' }}
                                _active={{ bg: 'green.700' }}
                            >
                                Completed
                            </Button>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td>Confirmation Statement</Td>
                        <Td>dd-mm-yyyy</Td>
                        <Td>
                            <Select w={'100%'}>
                                <option value="option1">Anually</option>
                                <option value="option2">Bi-Anually</option>
                            </Select>
                        </Td>
                        <Td textAlign={'center'}>
                            <Button
                                bg={"gray.600"}
                                _hover={{ bg: "gray.700" }}
                                _active={{ bg: "gray.800" }}
                                color={'white'}
                                size={'md'}
                            >
                                -
                            </Button>
                        </Td>
                        <Td>
                            <Button
                                size={'md'}
                                leftIcon={<FaCheck />}
                                color={'white'}
                                bg={'green.500'}
                                _hover={{ bg: 'green.600' }}
                                _active={{ bg: 'green.700' }}
                            >
                                Completed
                            </Button>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td>Corporation Tax</Td>
                        <Td>dd-mm-yyyy</Td>
                        <Td>
                            <Select w={'100%'}>
                                <option value="option1">Anually</option>
                                <option value="option2">Bi-Anually</option>
                            </Select>
                        </Td>
                        <Td textAlign={'center'}>
                            <Button
                                bg={"gray.600"}
                                _hover={{ bg: "gray.700" }}
                                _active={{ bg: "gray.800" }}
                                color={'white'}
                                size={'md'}
                            >
                                -
                            </Button>
                        </Td>
                        <Td>
                            <Button
                                size={'md'}
                                leftIcon={<FaCheck />}
                                color={'white'}
                                bg={'green.500'}
                                _hover={{ bg: 'green.600' }}
                                _active={{ bg: 'green.700' }}
                            >
                                Completed
                            </Button>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td>VAT Filling</Td>
                        <Td>dd-mm-yyyy</Td>
                        <Td>
                            <Select w={'100%'}>
                                <option value="option1">Anually</option>
                                <option value="option2">Bi-Anually</option>
                            </Select>
                        </Td>
                        <Td textAlign={'center'}>
                            <Button
                                bg={"gray.600"}
                                _hover={{ bg: "gray.700" }}
                                _active={{ bg: "gray.800" }}
                                color={'white'}
                                size={'md'}
                            >
                                -
                            </Button>
                        </Td>
                        <Td>
                            <Button
                                size={'md'}
                                leftIcon={<FaCheck />}
                                color={'white'}
                                bg={'green.500'}
                                _hover={{ bg: 'green.600' }}
                                _active={{ bg: 'green.700' }}
                            >
                                Completed
                            </Button>
                        </Td>
                    </Tr>
                </Tbody>
            </Table>
        </TableContainer>
    )
}